import { featuredFilms, heroStats } from "@/mocks/films";

export default function Hero() {
  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative w-full min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20retro%20Hong%20Kong%20cinema%20street%20at%20night%2C%20warm%20neon%20signs%20and%20glowing%20marquee%20lights%20reflected%20on%20wet%20pavement%2C%20painterly%20illustration%2C%20deep%20crimson%20red%20and%20warm%20gold%20tones%2C%20no%20text%2C%20moody%20cinematic%20atmosphere%2C%20soft%20film%20grain%2C%20rich%20shadows%20and%20glowing%20highlights&width=1920&height=1080&seq=dashixiong-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/60 via-transparent to-secondary-950/50"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-14 md:pb-20">
        <div className="max-w-3xl mx-auto text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/15 border border-background-100/30 text-background-50 text-xs md:text-sm font-label">
            <i className="ri-film-line" aria-hidden="true"></i>
            港片 · 经典电影 · 动作片 · 武侠片 · 老电影
          </span>

          <h1 className="mt-5 font-heading font-black text-background-50 text-3xl sm:text-4xl md:text-5xl leading-tight md:leading-[1.2]">
            大师兄影视 · 把港片与经典电影
            <span className="block mt-2 text-accent-400">重新摆回银幕中央</span>
          </h1>

          <p className="mt-5 text-background-200/90 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
            这里按类型与年代整理港片、经典电影、动作片与武侠片的片单线索，也保留老电影与怀旧剧场的慢看方式。
            你可以从下方推荐卡片快速进入，也可以在「片单筛选」里按标签或关键词自己找。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              type="button"
              onClick={() => jump("browse")}
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-search-eye-line mr-1.5" aria-hidden="true"></i>
              开始筛选片单
            </button>
            <button
              type="button"
              onClick={() => jump("hk-classics")}
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-background-50/10 border border-background-100/40 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              <i className="ri-bookmark-3-line mr-1.5" aria-hidden="true"></i>
              看港片精选
            </button>
          </div>

          <dl className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 max-w-xl mx-auto">
            {heroStats.map((s) => (
              <div key={s.id} className="rounded-lg bg-background-50/10 border border-background-100/25 px-3 py-3">
                <dt className="font-heading text-xl md:text-2xl font-bold text-accent-400">{s.value}</dt>
                <dd className="mt-1 text-[11px] md:text-xs text-background-200/85 font-label">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div id="featured" className="mt-12 md:mt-16 scroll-mt-24">
          <div className="flex items-end justify-between gap-4 mb-4">
            <div>
              <h2 className="font-heading text-lg md:text-xl font-bold text-background-50">首屏推荐 · 四部并看</h2>
              <p className="mt-1 text-xs md:text-sm text-background-200/80">同一时期、不同路数的四条入口，先感受港片的节奏差异。</p>
            </div>
            <span className="hidden sm:flex items-center gap-1.5 text-xs text-background-200/70 font-label whitespace-nowrap">
              <i className="ri-arrow-down-line animate-soft-pulse" aria-hidden="true"></i>
              向下展开全部内容
            </span>
          </div>

          <ul className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {featuredFilms.map((film) => (
              <li
                key={film.id}
                className="group relative rounded-lg overflow-hidden border border-background-100/25 bg-background-950/40"
              >
                <div className="w-full h-[220px] sm:h-[260px] md:h-[300px] overflow-hidden">
                  <img
                    src={film.image}
                    alt={`${film.title} 相关风格海报`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <div className="flex items-center gap-2 text-[11px] text-background-200/80 font-label">
                    <span className="text-accent-400 font-semibold">{film.year}</span>
                    <span className="w-px h-3 bg-background-100/30"></span>
                    <span className="truncate">{film.tags.join(" · ")}</span>
                  </div>
                  <h3 className="mt-1 font-heading text-base md:text-lg font-bold text-background-50 truncate">
                    {film.title}
                  </h3>
                  <p className="mt-1 text-[11px] md:text-xs text-background-200/80 leading-relaxed line-clamp-2">
                    {film.summary}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}